import {
    Paper,
    Table,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    TableContainer,
    TableBody,
    Box,
    Grid,
} from "@mui/material";
import React from "react";
import {NbaSummaryData} from "../../../../../types/nbaTypes";
import {QuerySummaryTableRow} from "./components/QuerySummaryTableRow";
import {QuerySummaryTableHeaders} from "./components/QuerySummaryTableHeaders";
import {calculatePercentage} from "../../../../../utils/helperFunctions";
import {SaveTrendButton} from "../../../../atoms/SaveTrendButton/SaveTrendButton";
import {useLocation} from "react-router-dom";
import {TrendTypeSelector} from "../TrendFinder/components/TrendTypeSelector/TrendTypeSelector";

export const QuerySummaryTable = (
        {
            summaryData,
            setIsSaveTrendDialogOpen,
            hideSaveButton = false,
            hideHeader = false,
            queryHasAtClause = false,
            loading = false,
            sport = '',
            queryString = '',
        }:
        {
            setIsSaveTrendDialogOpen: (isOpen: boolean) => void,
            summaryData?: NbaSummaryData,
            hideSaveButton?: boolean,
            hideHeader?: boolean,
            queryHasAtClause?: boolean,
            queryString: string,
            sport: string,
            loading?: boolean,
        }) => {
    const {pathname, search} = useLocation();
    const isTrendFinderView = pathname.includes('matchupTeams') || pathname.includes('trend-finder')
    if (!queryHasAtClause) {
        const {wins, losses, atsWins, atsLosses, overs, unders} = summaryData || {};
        const winPercentage = calculatePercentage(wins, losses);
        const atsWinPercentage = calculatePercentage(atsWins, atsLosses);
        const ouWinPercentage = calculatePercentage(overs, unders);

        return (
            <Box>
                {hideHeader ? '' : ''
                    // <Grid
                    //     item
                    //     container
                    //     xs={12}
                    //     pl={3.5}
                    //     pr={3.5}
                    //     display="flex"
                    //     justifyContent="center"
                    //     alignItems="center"
                    //
                    // >
                    //     <SaveTrendButton
                    //         handleSubmit={() => setIsSaveTrendDialogOpen(true)}
                    //         queryString={queryString}
                    //     />
                    //     <Typography
                    //         align="center"
                    //         variant="caption"
                    //         component="p"
                    //         color="grey"
                    //         mb={.5}
                    //         pr={3.5}
                    //         pl={2}
                    //         pt={1}
                    //     >
                    //         Records & Averages for {sport.toUpperCase()} Query String:
                    //         <Typography
                    //             variant="caption"
                    //             style={{fontWeight: 1000}}
                    //         >
                    //             {` ${queryString}`}
                    //         </Typography>
                    //     </Typography>
                    // </Grid>

                }
                <TableContainer
                    component={Paper}
                    style={{
                        maxWidth: '96%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: '4px'
                    }}
                >
                    <Table>
                        <QuerySummaryTableHeaders/>
                        <TableBody>
                            <QuerySummaryTableRow
                                wins={wins}
                                losses={losses}
                                winPercentage={winPercentage}
                                atsWins={atsWins}
                                atsLosses={atsLosses}
                                atsWinPercentage={atsWinPercentage}
                                summaryData={summaryData}
                                overs={overs}
                                unders={unders}
                                ouWinPercentage={ouWinPercentage}
                                loading={loading}
                            />
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )
    }

    return (
        <TableContainer
            // key={key}
            component={Paper}
            style={{
                maxWidth: '96%',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '4px',
                marginBottom: '12px'
            }}
        >
            <Table>
                <TableHead>
                    {Object.keys(summaryData?.dynamicFields || [])?.map((property: string, index) => {
                        const valueAtIndex = Object.values(summaryData?.dynamicFields || [])[index]
                        const valueAtIndexExists = valueAtIndex === 0 || !!valueAtIndex
                        if (valueAtIndexExists && property !== '__typename') {
                            return (
                                <TableCell align="left" key={index}>
                                    <Typography style={{fontWeight: '600'}} variant="caption">
                                        {property}
                                    </Typography>
                                </TableCell>
                            )
                        }

                        return null;
                    })}
                </TableHead>
                <TableBody>
                    <TableRow
                        sx={{
                            '& > *': {
                                paddingTop: '9px !important',
                                paddingBottom: '9px !important'
                            },
                            '&:hover': {
                                backgroundColor: 'lightgrey',
                                cursor: 'pointer',
                            },
                        }}
                    >
                        {Object.values(summaryData?.dynamicFields || [])?.map((value: any, index: number) => {
                            const numericalValue = !!value && +(value);
                            const stringValue = !!value && value.toString()

                            if (numericalValue || stringValue) {
                                return (
                                    <TableCell align="left" key={index}>
                                        {typeof value === 'number' ? value.toFixed(3) : value}
                                    </TableCell>
                                )
                            }
                            return null;
                        })}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}